import Vue from 'vue'
import VRefreshScrollEvent  from './refreshScrollEvent'

export default VRefreshScrollEvent




// WEBPACK FOOTER //
// ./src/components/refreshScrollEvent/index.js